import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TKadoTyoseiListGetReq,
  TKadoTyoseiListGetRes,
  TKadoTyoseiPutReq,
} from "./TKadoTyosei"

/**
 * 稼働調整に対するAPIリクエスト用サービス
 *
 * @export
 * @class KadoTyoseiService
 * @extends {ConnectApi}
 */
export default class KadoTyoseiService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TKadoTyoseiListGetReq} params
   * @memberof KadoTyoseiService
   */
  getList = async (params: TKadoTyoseiListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TKadoTyoseiListGetRes[]>> =
        await this.getInner(`/driver/zyomuinkadotyoseiharituke`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 給与実績更新
   *
   * @param {TZyomuinKyuyoRegisterPutReq} data
   * @memberof KadoTyoseiService
   */
  put = async (data: TKadoTyoseiPutReq[]) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/driver/zyomuinkadotyoseiharituke`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
